import { axiosInstance, getRequest } from "./apiService";

export const getParticipants = () => {
    return getRequest("/participants").then((response) => response.data);
}